import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaMutedCapable, isMediaVolumeCapable } from "@videojs/media";
//#region src/dom/store/features/volume.ts
/** Volume to restore when unmuting at zero. */
const UNMUTE_VOLUME = .25;
const volumeFeature = definePlayerFeature({
	name: "volume",
	state: ({ target, set }) => ({
		volume: 1,
		muted: false,
		volumeAvailability: "unavailable",
		mutedAvailability: "unavailable",
		setVolume(volume) {
			const { media } = target();
			if (!isMediaVolumeCapable(media)) return 0;
			const clamped = Math.max(0, Math.min(1, volume));
			if (clamped > 0 && media.muted) media.muted = false;
			media.volume = clamped;
			set({
				volume: media.volume,
				muted: media.muted
			});
			return media.volume;
		},
		toggleMuted() {
			const { media } = target();
			if (!isMediaMutedCapable(media)) return false;
			if (!isMediaVolumeCapable(media)) {
				media.muted = !media.muted;
				return media.muted;
			}
			if (media.muted || media.volume === 0) {
				media.muted = false;
				if (media.volume === 0) media.volume = UNMUTE_VOLUME;
			} else media.muted = true;
			return media.muted;
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		const volumeCapable = isMediaVolumeCapable(media);
		const mutedCapable = isMediaMutedCapable(media);
		if (!volumeCapable && !mutedCapable) return;
		set({
			volumeAvailability: volumeCapable ? canSetVolume() : "unavailable",
			mutedAvailability: mutedCapable ? "available" : "unavailable"
		});
		const sync = () => set({
			volume: volumeCapable ? media.volume : 1,
			muted: mutedCapable ? media.muted : false
		});
		sync();
		listen(media, "volumechange", sync, { signal });
	}
});
/** Check if volume can be programmatically set (fails on iOS Safari). */
function canSetVolume() {
	const video = document.createElement("video");
	try {
		video.volume = .5;
		return video.volume === .5 ? "available" : "unsupported";
	} catch {
		return "unsupported";
	}
}
//#endregion
export { volumeFeature };

//# sourceMappingURL=volume.js.map